import { yupResolver } from "@hookform/resolvers/yup";
import CardDetail from "components/Common/CardDetail";
import { CommonText } from "components/Common/TextCommon";
import { KPI_MANAGEMENT } from "constants/dataDashboard";
import moment from "moment/moment";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Card, Col, Container, Row } from "reactstrap";
import httpService from "services/httpService";
import KPIAssignment from "../KPIAssignment";
import * as yup from "yup";
import SelectConst from "components/form-control/SelectConst";
import { ChartKpi } from "components/Common/ChartKpi";
import VVSTable from "components/form-control/VVSTable";
import { CommonButton } from "components/Common/ButtonCommon";
import Spacer from "components/Common/Spacing";
import { formatNumber } from "helpers/erp_helper";
import SelectField from "components/form-control/Select";

const HEADERS1 = [
  {
    name: "Tổng doanh thu",
    value: "saleTotal",
  },
  {
    name: "Tổng số KPI thưởng",
    value: "bonus",
  },
  {
    name: "Tổng hoa hồng",
    value: "commision",
  },
];

export default function KPIManagement() {
  const [incomeChartMonth, setIncomeChartMonth] = useState([]);
  const [incomeChartDay, setIncomeChartDay] = useState([]);
  const [dataEmployeeGroup, setDataEmployeeGroup] = useState([]);
  const [dataEmployee, setDataEmployee] = useState([]);
  const [dataExtra, setDataExtra] = useState([]);
  const [dataEly, setdataEly] = useState("employeeId");
  const [dataElyG, setDataElyG] = useState("groupId");
  const [dataSummary, setDataSummary] = useState({});

  const [dateFrom, setDateFrom] = useState(moment().format("YYYY-MM-DD"));
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [kpiGroup, setKpiGroup] = useState([]);

  const [kpiEmployee, setKpiEmployee] = useState([]);
  const [colorsHex, setColorsHex] = useState([]);
  const [dataTableChart, setDataTableChart] = useState([]);
  const [queryFilter, setQueryFilter] = useState({});

  const [showChart, setShowChart] = useState("saleTotal");

  const DATE_FORMAT = "YYYY-MM-DD";

  useEffect(async () => {
    const kpiAssignmentUrl = `/parse/classes/KPIAssignment`;
    const params = {
      params: {
        where: {
          ...(dataElyG === "groupId"
            ? ""
            : {
                team: {
                  objectId: dataElyG,
                  className: "EmployeeGroup",
                  __type: "Pointer",
                },
              }),

          ...(dataEly === "employeeId"
            ? ""
            : {
                employee: {
                  objectId: dataEly,
                  className: "Employee",
                  __type: "Pointer",
                },
              }),
        },
      },
    };
    const resKpiAssignment = await httpService.get(kpiAssignmentUrl, params);

    const dataFindSumary = resKpiAssignment.results.reduce(
      (total, current) => {
        total.bonus += current.bonus;
        total.contractTotal += current.contractTotal;
        total.saleTotal += current.saleTotal;
        total.commission += current.commission;

        return total;
      },
      { bonus: 0, contractTotal: 0, saleTotal: 0, commission: 0 }
    );

    setDataSummary(dataFindSumary);
  }, [dataEly, dataElyG]);

  useEffect(() => {
    getAllKpi();
  }, []);

  const getAllKpi = async () => {
    const { setValue } = rest;
    const employeeGroupUrl = `/parse/classes/EmployeeGroup?where={"isActive": true}`;
    const employeeUrl = "/parse/classes/Employee";

    const res = await httpService.get(employeeGroupUrl);

    const resEmployee = await httpService.get(employeeUrl);

    const employeeOption = resEmployee.results.map((item, index) => {
      return {
        text: item.fullName,
        value: item.objectId,
      };
    });
    const allEmployeeOption = [
      { text: "Tất cả nhân viên", value: "employeeId" },
      ...employeeOption,
    ];

    const employeeGroupOption = res.results.map((item, index) => {
      return {
        text: item.name,
        value: item.objectId,
      };
    });

    const allGroupOption = [
      {
        text: "Tất cả đội nhóm",
        value: "groupId",
      },
      ...employeeGroupOption,
    ];
    setColorsHex(randomColor(res.results.length));
    setDataEmployee(allEmployeeOption);
    setDataEmployeeGroup(allGroupOption);
    setDataExtra(res.results);
    setKpiGroup(res.results);
    setKpiEmployee(resEmployee.results);
    setValue("team", "groupId");
    setValue("employee", "employeeId");
  };

  const getEmployee = async e => {
    const employeeUrl = "/parse/classes/Employee";
    const params = {
      params: {
        where: {
          ...(e && {
            group: {
              objectId: e,
              className: "EmployeeGroup",
              __type: "Pointer",
            },
          }),
        },
      },
    };
    const resEmployee = await httpService.get(employeeUrl, params);

    const employeeOption = resEmployee.results.map((item, index) => {
      return {
        text: item.fullName,
        value: item.objectId,
      };
    });
    const allEmployeeOption = [
      { text: "Tất cả nhân viên", value: "employeeId" },
      ...employeeOption,
    ];

    setDataEmployee(allEmployeeOption);
  };

  const randomColor = colorsNum => {
    const colors = [];
    for (let i = 0; i < colorsNum; i += 1) {
      var randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16);
      colors.push(randomColor);
    }
    return colors;
  };

  const filterData = async e => {
    const { setValue } = rest;
    const findGroup = dataEmployeeGroup.find(item => item.value === e);

    if (findGroup.value === "groupId") {
      setDataElyG(e);
      setValue("employee", "employeeId");
      const test1 = kpiEmployee.map(item => {
        return {
          value: item.objectId,
          text: item.fullName,
        };
      });
      test1.unshift({ text: "Tất cả nhân viên", value: "employeeId" });
      setDataEmployee(test1);
      setDataExtra(kpiGroup);
      return;
    }

    const selectedGroup = kpiGroup.find(item => item.objectId === e);
    setDataExtra([selectedGroup]);
    getEmployee(e);
    setDataElyG(e);
  };

  useEffect(() => {
    getDataForIncomeChart(
      moment().startOf("month").format(DATE_FORMAT),
      moment().endOf("month").format(DATE_FORMAT)
    ).then(result => setIncomeChartMonth(result));

    getDataForIncomeChart(
      moment().startOf("day").format(DATE_FORMAT),
      moment().endOf("day").format(DATE_FORMAT)
    ).then(result => setIncomeChartDay(result));
  }, []);

  const schema = yup

    .object({})

    .required();

  const {
    formState: { errors },
    ...rest
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const getDataForIncomeChart = async (dateFrom, dateTo) => {
    const url = "parse/functions/order-summary";
    try {
      const resp = await httpService.post(url, { dateFrom, dateTo });

      if (resp.result && resp.result.statusCode === 201) {
        return resp.result.data;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getCount = index => {
    switch (index) {
      case 1:
        return formatNumber(dataSummary?.bonus) || 0;
        break;
      case 2:
        return formatNumber(dataSummary?.saleTotal) || 0;
        break;
      case 3:
        return formatNumber(dataSummary?.commision) || 0;
        break;
      case 4:
        return Number(dataSummary?.contractTotal || 0);
        break;
    }
  };

  const changeEmployee = e => {
    const findEmloyee = dataEmployee.find(item => item.value === e);

    if (findEmloyee.value === "employeeId") {
      setdataEly(e);
      setKpiEmployee(kpiEmployee);
      return;
    }

    const selectedEmployee = kpiEmployee.find(item => item.objectId === e);
    setdataEly(e);
    setDataExtra([selectedEmployee]);
  };

  useEffect(() => {
    filterTable();
  }, [dataEly, dataElyG]);

  const filterTable = (dateFrom = "", dateTo = "") => {
    if (!dataExtra.length) return {};

    if (dataEly === "employeeId" && dataElyG === "groupId") {
      setQueryFilter({
        ...(dateFrom &&
          dateTo && {
            to: {
              $gte: {
                __type: "Date",
                iso: dateFrom,
              },
              $lte: {
                __type: "Date",
                iso: dateTo,
              },
            },
          }),
      });
      return {};
    }

    setQueryFilter({
      ...(dataEly !== "employeeId" && {
        employee: {
          __type: "Pointer",
          objectId: dataEly,
          className: "Employee",
        },
      }),

      ...(dataElyG !== "groupId" && {
        team: {
          __type: "Pointer",
          objectId: dataElyG,
          className: "EmployeeGroup",
        },
      }),

      ...(dateFrom &&
        dateTo && {
          to: {
            $gte: {
              __type: "Date",
              iso: dateFrom,
            },
            $lte: {
              __type: "Date",
              iso: dateTo,
            },
          },
        }),
    });
  };

  const onClickFilter = async () => {
    const payload = {
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
    };

    const startDate = moment(payload.dateFrom)
      .startOf("month")
      .format("YYYY-MM-DD");
    const endDate = moment(payload.dateTo).endOf("month").format("YYYY-MM-DD");

    filterTable(startDate, endDate);
  };

  const chartRef = useRef();

  const onTableChangeHandler = data => {
    chartRef.current.reRender(data);

    const dataFindSumary = data.reduce(
      (total, current) => {
        total.bonus += current.bonus;
        total.contractTotal += current.contractTotal;
        total.saleTotal += current.saleTotal;
        total.commission += current.commission;

        return total;
      },
      { bonus: 0, contractTotal: 0, saleTotal: 0, commission: 0 }
    );
    setDataSummary(dataFindSumary);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <CommonText level={3} color="#1A1A1A" mb={17}>
          Báo cáo KPI
        </CommonText>
        <Card body>
          <Row>
            <Col xs={3}>
              <div style={{ minHeight: 89 }}>
                <SelectConst
                  label="Đội nhóm"
                  name="team"
                  errors={errors}
                  {...rest}
                  options={dataEmployeeGroup}
                  onChange={e => filterData(e.target.value)}
                />
              </div>
            </Col>

            <Col xs={3}>
              <SelectConst
                label="Nhân viên"
                name="employee"
                errors={errors}
                {...rest}
                options={dataEmployee}
                onChange={e => changeEmployee(e.target.value)}
              />
            </Col>

            <Col xs={3} className="d-flex">
              <div className="d-flex align-items-center">
                <div style={{ marginRight: "20px" }}>
                  <CommonText level={8} mt={0} color={"#495057"}>
                    Từ tháng
                  </CommonText>
                  <input
                    type="month"
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "5px",
                      padding: "5px 10px",
                      color: "#495057",
                    }}
                    min="2022-01"
                    value={dateFrom}
                    onChange={e => setDateFrom(e.target.value)}
                  />
                </div>
                <div style={{ marginRight: "20px" }}>
                  <CommonText level={8} mt={0} color={"#495057"}>
                    Đến tháng
                  </CommonText>
                  <input
                    type="month"
                    lang="vi-VN"
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "5px",
                      padding: "5px 10px",
                      color: "#495057",
                    }}
                    value={dateTo}
                    onChange={e => setDateTo(e.target.value)}
                  />
                </div>
                <div style={{ marginRight: "18px", marginTop: "14px" }}>
                  <CommonButton level={0} onClick={() => onClickFilter()}>
                    Lọc
                  </CommonButton>
                </div>
              </div>
            </Col>
          </Row>
        </Card>

        <Row>
          {KPI_MANAGEMENT.map(item => (
            <Col xl={3} key={item.id}>
              <CardDetail item={item} number={getCount(item.id)} />
            </Col>
          ))}
        </Row>

        <Card body>
          <Col xl={3}>
            <SelectField
              label="Hiển thị"
              name="filterBy"
              options={HEADERS1}
              {...rest}
              errors={errors}
              onChange={e => {
                setShowChart(e.target.value);
              }}
            />
          </Col>
          <Spacer size={40} />
          <Row>
            <Col xl={6}>
              <ChartKpi
                ref={chartRef}
                colors={colorsHex}
                showChart={showChart}
              />
            </Col>
          </Row>
        </Card>
      </Container>

      <Spacer size={50} />
      <Container fluid>
        <VVSTable
          showExportExcel
          disableAdd
          disableSearch
          disableDelete
          title="Chỉ tiêu cho nhân viên"
          name="KPIAssignment1"
          whereQuery={queryFilter}
          onTableChangeHandler={onTableChangeHandler}
        />
      </Container>
    </div>
  );
}
